import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

import LabelService, { type ILabelActions } from './label-service';

// The context value IS the ILabelActions instance, so class components can read
// `this.context.get(...)` via `static contextType = LabelContext`.
export const LabelContext = createContext<ILabelActions>(undefined as any as ILabelActions);
LabelContext.displayName = 'LabelContext';

export type LabelProviderProps = {
  devEnv?: boolean;
  labels: Record<string, string>;
};

export const LabelProvider = ({ children, devEnv = false, labels }: PropsWithChildren<LabelProviderProps>) => {
  const labelActions = useMemo(() => new LabelService(devEnv, labels), [devEnv, labels]);

  return <LabelContext.Provider value={labelActions}>{children}</LabelContext.Provider>;
};

export const useLabelActions = (): ILabelActions => {
  const context = useContext(LabelContext);
  if (!context) {
    throw new Error('useLabelActions can only be used inside of LabelProvider');
  }

  return context;
};
